export default __webpack_public_path__ + "static/media/ArrowRightIcon.6add9f2f.svg";